import { http, HttpResponse } from 'msw';
import { devicesMocks, authMocks } from '../mocks';

export const getAllDeviceHandler = http.get(
  '*/00000000-0000-0000-0000-000000000000/devices*',
  () =>
    HttpResponse.json({
      devices: devicesMocks.devices,
      Username: authMocks.signInMock.User.Username
    })
);

export const getDevice = http.get('*/devices/:deviceId', ({ params }) =>
  HttpResponse.json(devicesMocks.devices.find((d) => d.Id === params.deviceId))
);

export const happyhour = http.get('*/devices/:deviceId/happyhour', () =>
  HttpResponse.json(devicesMocks.happyhour)
);

export const isHappyhour = http.get('*/devices/:deviceId/ishappyhour', () =>
  HttpResponse.json(false)
);

export const stats = http.get('*/device/:deviceId/sales/stats?*', () =>
  HttpResponse.json(devicesMocks.stats)
);

export const telemetry = http.get('*/devices/:deviceId/telemetry?*', () =>
  HttpResponse.json(devicesMocks.telemetry)
);
